// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"521":"783c8ae1","615":"dff54b29","686":"960e70d7"}[chunkId] + ".chunk.js";
};